import { ArrowRight, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Contacthero() {
  return <section data-section-id="253287" id="contacthero" className="relative overflow-hidden bg-background py-24 sm:py-32 lg:py-40 text-foreground">
      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none">
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_20%,transparent_100%)] opacity-10" />
        
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-primary/5 blur-[120px] rounded-lg animate-pulse" />
      </div>

      <div className="container relative z-10 mx-auto px-4 text-center">
        {}
        <div className="inline-flex items-center rounded-md border border-border bg-background/80 px-4 py-1.5 text-sm font-medium text-muted-foreground backdrop-blur-sm mb-8 shadow-sm">
          <BookOpen className="mr-2 h-4 w-4 text-primary" />
          <span>IATA GOlite Certified Boutique Agency</span>
        </div>

        {}
        <h1 className="font-serif text-5xl font-bold tracking-tight sm:text-6xl lg:text-7xl mb-6 max-w-4xl mx-auto text-primary">
          Connect With{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-muted-foreground to-primary bg-[length:200%_auto] animate-[pulse_4s_ease-in-out_infinite]">
            CircuitXtravel
          </span>
        </h1>

        {}
        <p className="mx-auto max-w-2xl text-lg sm:text-xl text-muted-foreground mb-10 leading-relaxed font-default">
          Experience the pinnacle of luxury travel tailored for the premium LGBTQ+ community. Our concierge team is ready to curate your next bespoke global adventure.
        </p>

        {}
        <div className="flex flex-col sm:flex-row justify-center gap-4 items-center">
          <Button asChild size="lg" className="rounded-md px-8 h-14 text-base w-full sm:w-auto shadow-md bg-primary text-white hover:opacity-90">
            <Link to="/PlanYourBespokeJourneyPage">
              Plan a Journey <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="rounded-md px-8 h-14 text-base w-full sm:w-auto bg-background/50 backdrop-blur-sm border-border hover:bg-accent hover:text-accent-foreground">
            <Link to="/OurStoryPage">
              Our Story
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}